import { graphql } from "../gql";

const getHeadToHeadOddsQuery = graphql(`
  query GetHeadToHeadOdds($input: OddsMarketTypesInput!) {
    event(input: $input) {
      historicalOdds {
        isLive
        timestamp
        homeSpread
        homeSpreadOdds
        awaySpread
        awaySpreadOdds
        homeMoneylineOdds
        awayMoneylineOdds
        ouTotalPoints
        overTotalPointsOdds
        underTotalPointsOdds
      }
      odds {
        moneyline {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          result {
            type
          }
          teamNumberFireId
          playerStat {
            value
            units
            period
          }
        }
        spread {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          teamNumberFireId
        }
        totalPoints {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          teamNumberFireId
        }
      }
    }
  }
`);

export default getHeadToHeadOddsQuery;
